<template>
  <div
    class="log-wrapper"
    v-loading="downloadLoding"
    element-loading-text="正在导出中..."
    element-loading-spinner="el-icon-loading"
  >
    <crm-panel :title="'系统日志'" style="overflow: auto">
      <section class="page-buttons">
        <crm-button
          v-if="auth.operationLogExport && auth.operationLogExport.toggleStatus"
          :buttonType="'secondary'"
          :text="'导出'"
          @click="handleDownload"
        >
        </crm-button>
      </section>

      <Search
        class="mt20"
        ref="searchRef"
        @handle-search="handleSearch(true)"
      />

      <Content
        style="height: 100%"
        v-loading="loading"
        :table-data="list.results"
        :total="list.totalCount"
        ref="contentRef"
        @handle-page-change="handleSearch"
      />
    </crm-panel>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import crmPanel from '@/components/base/crmPanel';
import crmButton from '@/components/base/crmButton';
import Search from './Search';
import Content from './Content';
import service from '@/services/api/backstage';

const MAX_DATA_LENGTH = 1000; // 允许导出的最大长度

export default {
  components: {
    crmPanel,
    Search,
    crmButton,
    Content,
  },
  data() {
    return {
      loading: false,
      downloadLoding: false,
      list: {},
    };
  },
  mounted() {
    // this.handleSearch()
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
    }),
  },
  methods: {
    async handleSearch(isChangeSearch = false) {
      try {
        this.loading = true;
        const key = this.$refs.searchRef.searchForm;
        const page = this.$refs.contentRef.page;
        if (isChangeSearch) page.pageNumber = 1;
        const payload = { ...key, ...page };
        const { data } = await service.apiQueryLog(payload);
        this.list = data;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    handleDownload() {
      if (this.list.totalCount > MAX_DATA_LENGTH) {
        this.$notify({
          title: '警告',
          message:
            '系统仅支持导出最新的1000条操作日志内容，需要导出更多内容，请联系开发人员！',
          type: 'error',
          showClose: false,
        });
      } else {
        try {
          service
            .apiDownloadLog({ ...this.$refs.searchRef.searchForm })
            .then((res) => {
              const fileName = res.headers['content-disposition']
                .split(';')[1]
                .split('=')[1]
                .split('.csv')[0];
              const blob = new Blob([res.data]);
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onload = async (e) => {
                // 转换完成，创建一个a标签用于下载
                const a = document.createElement('a');
                console.log(decodeURIComponent(fileName));
                a.download = `${decodeURIComponent(fileName)}`;
                if (typeof e.target.result === 'string') {
                  a.href = e.target.result;
                }
                a.click();
              };
            });
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.log-wrapper {
  display: flex;
  flex: 1;
  width: 100%;
  height: 100%;
}
</style>
